module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.b3673683.jpg";